import { authentication } from "@/services/auth";
import { Device } from "@/services/Device";
import { responses } from "@/utils/responses";
import Swal from "sweetalert2";
import Vue from 'vue'
import { utils } from "@/utils/utils";
import { errorHandler } from "@/services/errorHandler";
import queryStringify from "qs-stringify";
import store from "@/store";
import html2canvas from 'html2canvas';
import { dateTimeManager } from "@/services/TimeManager";
window.getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
import axios from "axios";
window.axios = axios;
Vue.prototype.$dateTimeManager = dateTimeManager;
//window.serverApi = `http://localhost:8181/OnlineSalesServer/`
window.serverApi = `https://lytningtomcat.chrilantech.com/OnlineSalesServer/`
// window.serverApi = `http://DESKTOP-JS3P555:7081/OnlineSalesServer/`

// Inform Electron main process to use the same serverApi for table sync
try {
    if (window.config && typeof window.config.setServerApi === 'function') {
        window.config.setServerApi(window.serverApi).catch(() => { });
    }
} catch (e) {
    // no-op if not in Electron
}


window.ticketApi = `https://lna.pos.co.zm/TicketApp/`
//window.ticketApi = `http://kabs:8080/TicketApp/`;

window.kazangSubscriptionApi = `https://lna.pos.co.zm/kazangApi/api/`

window.kazangApi = `https://realtime.pos.co.zm:8443/kazangApi/api/`
// window.kazangApi = `http://192.168.1.244:8181/kazangApi/api/`

window.gateWayApi = `https://realtime.pos.co.zm:8443/SandboxKazangPaymentGateway/api/GateWay/`
// window.gateWayApi = `http://192.168.1.225:9333/KazangPaymentGateway/api/GateWay/`


window.franchiseTomcatApi = `https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/`
// window.franchiseTomcatApi = `http://DESKTOP-JS3P555:7082/Franchise_OnlineServer/`

window.printApi = `https://lytningtomcat.chrilantech.com/PrintApi/`

window.loyaltyApi = `https://overflow.pos.co.zm/loyalty_service/loyalty/`
// window.loyaltyApi = `http://192.168.1.244:8181/loyalty_service/loyalty/`

window.zedMobileApi = `https://lna.pos.co.zm/ZedMobileApi/`
// window.zedMobileApi = `http://localhost:8181/ZedMobileApi/`

//window.backOfficeTomcatApi = `http://self:8080/Lyt-SoftBackOfficeApi/`
window.backOfficeTomcatApi = `https://lytningtomcat.chrilantech.com/Lyt-SoftBackOfficeApi/`
// window.backOfficeTomcatApi = `http://192.168.0.124:8282/Lyt-SoftBackOfficeApi/`

window.synergyApi = `https://lna.pos.co.zm/SynergyApi/api/v1/`

window.announcementsApi = `${window.synergyApi}announcements`

window.subscriptionApi = "https://lytningtomcat.chrilantech.com/SubscriptionManager/api/"
// window.subscriptionApi = `https:///subscription/api/`
// window.subscriptionApi = `http://localhost:8080/subscription/api/`

window.printVoid = `https://lytningtomcat.chrilantech.com/OnlinePrintService/`
//window.printVoid = `http://mcc:8282/OnlinePrintService/`

window.backOfficeApiPOST = franchiseTomcatApi + `proxyApi/lytSoftBackOffice/POST`;
window.backOfficeApiGET = franchiseTomcatApi + `proxyApi/lytSoftBackOffice/GET`;

window.androidMode = true;

// window.backOfficePlatform = `http://192.168.0.220:8082`;
window.backOfficePlatform = `https://admin.chrilantech.com`;

// Local Hardware Service removed: no window.hardwareApi
window.smartinvoicesearch = backOfficeTomcatApi + `other/`;
window.gateWayApiPOST = franchiseTomcatApi + `proxyApi/gateWay/POST`;
window.gateWayApiGET = franchiseTomcatApi + `proxyApi/gateWay/GET`;

window.subscriptionApiPOST = franchiseTomcatApi + `proxyApi/subscriptionApi/POST`;
window.subscriptionApiGET = franchiseTomcatApi + `proxyApi/subscriptionApi/GET`;

window.franchiseApi = `https://chrilantech.com/LytSoftPosOnline/api/`
window.franchiseApiLytning = `https://lytningtomcat.chrilantech.com/`
// window.franchiseApi = `http://127.0.0.1:8000/api/`

// window.franchiseSpringApi = `https://lna.pos.co.zm/FranchiseSpringServer/`
window.franchiseSpringApi = ` https://lytningtomcat.chrilantech.com/FranchiseSpringServer/`

window.lytstoreApi = `https://server.shop.co.zm/lyt-store/v1/stores`
//window.lytstoreApi = `http://mcc:8283/lyt-store/v1/stores`

//window.lodgingApi = `http://192.168.0.201:8084/api/external/v1/`
window.lodgingApi = `https://server.lodge.co.zm/smart-lodge-backend/api/external/v1/`

window.reportTomcatApi = `https://lytningtomcat.chrilantech.com/ReportsApi/`;
window.reportsApi = reportTomcatApi + `api/v2/cashup/`

window.auth = authentication;
window.Device = Device;
window.responses = responses;
window.errorHandler = errorHandler
window.routeExceptions = ['login', 'forgot-password', 'kazangOnline', 'test-success', 'test-failed', 'initKazangOnline',
    'signup', 'custom-install', 'custom-cart', 'validation', 'SelectUserView', 'OtpView', 'customer-display'];

const EventBus = new Vue()
window.EventBus = EventBus
window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

window.$utils = utils;


window.screenShot = async () => {
    Swal.close();
    let sheet = store.getters.getActiveSheet;
    if (sheet) {
        try {
            await sheet.close();
            await new Promise(resolve => setTimeout(resolve, 300));
        } catch (r) {
        }
    }
    return html2canvas(document.body).then(canvas => {
        let data = canvas.toDataURL('image/png');
        return data.split(';base64,')[1]
    }).catch(err => {
        console.error(err);
    }).finally(async () => {
        if (sheet) {
            try {
                await sheet.open();
            } catch (w) {
            }
        }
    });
}

Vue.prototype.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);



window.pageOptions = {
    enabled: true,
    mode: 'pages',
    perPage: 10,
    position: 'bottom',
    perPageDropdown: [10, 100, 200],
    dropdownAllowAll: false,
    jumpFirstOrLast: true,
    pageLabel: 'page',
}
window.openUrl = (url, target = '_blank') => window.open(url, target, "_blank", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=yes, width=900, height=700");
window.encryptObj = (object) => window.btoa(JSON.stringify(object));
window.decryptObj = (string) => window.atob(JSON.parse(string));

window.isValidString = (string) => {
    if (!string) return false;
    string = string.toString().trim();
    return !(string === `null` || string === `undefined` || string === ``);

}

// =====================================================================
// Autosigner (in-app update distribution) — see docs/exec-plans/active/
// 2026-06-23-app-update-flow.md
// ---------------------------------------------------------------------
// The downloader key is read here so the renderer can publish which
// channel/app/platform to check. The privileged HTTPS call itself is
// ALWAYS performed by the Electron main process; the renderer never
// makes the bearer-authenticated request directly. See
// electron/updater.js and the `updateAPI` exposed in preload.js.
// =====================================================================
window.autosignerApi = 'https://autosigner.abc.co.zm/v1/api';
window.autosignerAppId = 'lytning-restaurant';
// Platform is derived from process.platform in the Electron main
// process. The renderer-facing constant is for documentation only.
window.autosignerPlatform = 'windows';
// Downloader API key (downloads only, never admin or uploader).
// NOTE: this constant currently lives in the renderer bundle. Follow-up
// is to move the key to app.getPath('userData')/autosigner-config.json
// so it never enters the renderer bundle. The `updateAPI` contract
// does not need to change.
window.autosignerDownloaderKey = 'REPLACE_WITH_AUTOSIGNER_DOWNLOADER_KEY';